<br/>
<div class="container">
    <div class="row mx-auto w-100">
        <h2>Next to Arrive</h2>    
    </div>
    
    <div class="row d-flex p-2 text-center">
        <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-bus-tab" data-toggle="tab" href="#nav-bus" role="tab" aria-controls="nav-bus" aria-selected="true">
                    <div class="status-icons">
                        <img class="status-icons" src="../../../assets/images/modes/bus/bus-status-dark.png">
                        
                    </div>
                    <span class="badge">
                        Bus
                    </span>
                </a>
                <a class="nav-item nav-link" id="nav-rail-tab" data-toggle="tab" href="#nav-rail" role="tab" aria-controls="nav-rail" aria-selected="false">
                    <div class="status-icons">
                        <img class="status-icons" src="../../../assets/images/modes/rail/rail-status.png">
                    </div>
                    <span class="badge">
                        Rail
                    </span>
                </a>
                <a class="nav-item nav-link" id="nav-subway-tab" data-toggle="tab" href="#nav-subway" role="tab" aria-controls="nav-subway" aria-selected="false">
                    <div class="status-icons icon-inactive">
                        <img class="status-icons" src="../../../assets/images/modes/nhsl/nhsl-status.png">
                    </div>
                    <span class="badge">
                        Subway/NHSL
                    </span>
                </a>
                <a class="nav-item nav-link" id="nav-trolley-tab" data-toggle="tab" href="#nav-trolley" role="tab" aria-controls="nav-trolley" aria-selected="false">
                    <div class="status-icons icon-inactive">
                        <img class="status-icons" src="../../../assets/images/modes/trolley/trolley-status.png">
                    </div>
                    <span class="badge">
                        Trolley
                    </span>
                </a>
            </div>
        </nav>
    </div>
    <div class="tab-content" id="nav-tabContent">
        <div class="tab-pane fade show active" id="nav-bus" role="tabpanel" aria-labelledby="nav-bus-tab">
            <form>
                <div class="form-group">
                    <label for="bus-route-selection">Line</label>
                    <input type="text" class="form-control" id="bus-route-selection" aria-describedby="bus-route-selection" placeholder="Select Route">
                </div>
                <div class="form-group">
                    <label for="bus-start-selection">Starting Stop</label>
                    <input type="text" class="form-control" id="bus-start-selection" aria-describedby="bus-start-selection" placeholder="Starting Stop">
                </div>
                <div class="form-group">
                    <label for="bus-destination-selection">Destination Stop</label>
                    <input type="text" class="form-control" id="bus-destination-selection" aria-describedby="bus-destination-selection" placeholder="Destination Stop">
                </div>
                <div class="form-group">
                    <button type="button" class="btn btn-primary">Next to Arrive</button>
                </div>
            </form>
        </div>
        <div class="tab-pane fade" id="nav-rail" role="tabpanel" aria-labelledby="nav-rail-tab">
            <form>
                <div class="form-group">
                    <label for="rail-start-selection">Starting Stop</label>
                    <input type="text" class="form-control" id="rail-start-selection" aria-describedby="rail-start-selection" placeholder="Starting Stop">
                </div>
                <div class="form-group">
                    <label for="rail-destination-selection">Destination Stop</label>
                    <input type="text" class="form-control" id="rail-destination-selection" aria-describedby="rail-destination-selection" placeholder="Destination Stop">
                </div>
                <div class="form-group">
                    <button type="button" class="btn btn-primary">Next to Arrive</button>
                </div>
            </form>
        </div>
        <div class="tab-pane fade" id="nav-subway" role="tabpanel" aria-labelledby="nav-subway-tab">
            <form>
                <div class="form-group">
                    <label for="subway-route-selection">Line</label>
                    <input type="text" class="form-control" id="subway-route-selection" aria-describedby="subway-route-selection" placeholder="Select Route">
                </div>
                <div class="form-group">
                    <label for="subway-start-selection">Starting Stop</label>
                    <input type="text" class="form-control" id="subway-start-selection" aria-describedby="subway-start-selection" placeholder="Starting Stop">
                </div>
                <div class="form-group">
                    <label for="subway-destination-selection">Destination Stop</label>
                    <input type="text" class="form-control" id="subway-destination-selection" aria-describedby="subway-destination-selection" placeholder="Destination Stop">
                </div>
                <div class="form-group">
                    <button type="button" class="btn btn-primary">Next to Arrive</button>
                </div>
            </form>
        </div>
        <div class="tab-pane fade" id="nav-nhsl" role="tabpanel" aria-labelledby="nav-nhsl-tab">
            <form>
                <div class="form-group">
                    <label for="nhsl-route-selection">Line</label>
                    <input type="text" class="form-control" id="nhsl-route-selection" aria-describedby="nhsl-route-selection" placeholder="Select Route">
                </div>
                <div class="form-group">
                    <label for="nhsl-start-selection">Starting Stop</label>
                    <input type="text" class="form-control" id="nhsl-start-selection" aria-describedby="nhsl-start-selection" placeholder="Starting Stop">
                </div>
                <div class="form-group">
                    <label for="nhsl-destination-selection">Destination Stop</label>
                    <input type="text" class="form-control" id="nhsl-destination-selection" aria-describedby="nhsl-destination-selection" placeholder="Destination Stop">
                </div>
                <div class="form-group">
                    <button type="button" class="btn btn-primary">Next to Arrive</button>
                </div>
            </form>
        </div>
        <div class="tab-pane fade" id="nav-trolley" role="tabpanel" aria-labelledby="nav-trolley-tab">
            <form>
                <div class="form-group">
                    <label for="trolley-route-selection">Line</label>
                    <input type="text" class="form-control" id="trolley-route-selection" aria-describedby="trolley-route-selection" placeholder="Select Route">
                </div>
                <div class="form-group">
                    <label for="trolley-start-selection">Starting Stop</label>
                    <input type="text" class="form-control" id="trolley-start-selection" aria-describedby="trolley-start-selection" placeholder="Starting Stop">
                </div>
                <div class="form-group">
                    <label for="trolley-destination-selection">Destination Stop</label>
                    <input type="text" class="form-control" id="trolley-destination-selection" aria-describedby="trolley-destination-selection" placeholder="Destination Stop">
                </div>
                <div class="form-group">
                    <button type="button" class="btn btn-primary">Next to Arrive</button>
                </div>
            </form>
        </div>
    </div>
</div>